/* eslint-disable no-shadow */
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import '../index.scss';

import iconDelete from '../../../assets/images/icon_delete_white.svg';

import {
  setCurrentTemplateBotTesting,
  setCurrentTemplateBotSelected,
} from '../../../store/actions/new-bot';
import { setTemplateBotData } from '../../../store/actions/template-bot';

const categoryStyle = { color: '#D8D8D8' };
const tryTemplateStyle = {
  backgroundColor: '#ffffff',
  color: '#3D4859',
  fontWeight: '500',
};

const NewBotTemplateCard = (props) => {
  const {
    showLearnMoreModal,
    isEditMode,
    template,
    originalTemplateBots,
    currentTemplateBotTesting,
  } = props;
  const {
    _id: templateId,
    title,
    category,
    shortDescription,
    banner,
  } = template;

  const onClickSelectTempleBot = (event) => {
    event.preventDefault();
    const { setCurrentTemplateBotSelected } = props;
    setCurrentTemplateBotSelected(template);
  };

  const onClickTryTemplateBot = (event) => {
    event.preventDefault();
    const { isOpen } = currentTemplateBotTesting;
    const { setCurrentTemplateBotTesting, chatRef } = props;
    const { botId, title } = template;
    setCurrentTemplateBotTesting({ botId, title, isOpen: true });
    if (isOpen && chatRef.current && chatRef.current.resetPreview) {
      chatRef.current.resetPreview();
    }
  };

  const onClickLearnMore = (event) => {
    event.preventDefault();
    const { setLearnMoreData } = props;
    setLearnMoreData(template);
  };

  const onClickEditTemplate = (event) => {
    event.preventDefault();
    const { setTemplateBotData, setShowEditTemplateModal } = props;
    setTemplateBotData(template);
    setShowEditTemplateModal(true);
  };

  const onClickDeleteTemplate = (event) => {
    event.preventDefault();
    const newOriginalTemplateBots = [...originalTemplateBots];
    const hasTemplate = newOriginalTemplateBots.find(
      ({ _id }) => _id === templateId
    );

    if (hasTemplate) {
      const { setOriginalTemplateBots } = props;
      const index = newOriginalTemplateBots.indexOf(hasTemplate);
      newOriginalTemplateBots.splice(index, 1);
      setOriginalTemplateBots(newOriginalTemplateBots);
    }
  };

  const renderManagerTemplateActions = () => {
    return (
      <div className="new-bot-template-list-actions-column">
        <label>{title}</label>
        <button
          type="button"
          className="new-bot-template-list-edit-button"
          onClick={onClickEditTemplate}
        >
          <label>Editar template</label>
        </button>
        <button
          type="button"
          className="new-bot-template-list-delete-button"
          onClick={onClickDeleteTemplate}
        >
          <img src={iconDelete} alt="Icon Delete" />
          <label>Apagar template</label>
        </button>
      </div>
    );
  };

  const renderActions = () => {
    if (showLearnMoreModal) {
      return (
        <div className="new-bot-content-card-title-modal-open">
          <span>{title}</span>
        </div>
      );
    }

    if (isEditMode) {
      return (
        <div className="new-bot-content-card-actions-modal-open">
          {renderManagerTemplateActions()}
        </div>
      );
    }

    return (
      <div className="new-bot-card-actions">
        <span>{title}</span>
        <span style={categoryStyle}>{category}</span>
        <br />
        <div className="new-bot-card-actions-content">
          <label>{shortDescription}</label>
          <br />
          <a href="#/" onClick={onClickLearnMore}>
            saiba mais
          </a>
          <br />
          <div className="new-bot-card-buttons">
            <button type="button" onClick={onClickSelectTempleBot}>
              Usar este
            </button>
            <button
              type="button"
              onClick={onClickTryTemplateBot}
              style={tryTemplateStyle}
            >
              Testar
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="new-bot-content-card">
      <img src={banner} alt="Banner" />
      {renderActions()}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    currentTemplateBotTesting: state.newBot.currentTemplateBotTesting,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setCurrentTemplateBotTesting,
      setCurrentTemplateBotSelected,
      setTemplateBotData,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(NewBotTemplateCard);
